import {
  BrowserRouter, Routes, Route 
} from 'react-router-dom';
import {
  QueryClient, QueryClientProvider 
} from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { AuthProvider } from './providers/auth-provider';
import { AppLayout } from './components/layout/app-layout';
import { DashboardPage } from './pages/dashboard';
import { LoginPage } from './pages/login';
import { SetPasswordPage } from './pages/set-password';
import { ForgotPasswordPage } from './pages/forgot-password';
import { ProtectedRoute } from './components/auth/protected-route';
import {
  PurchaseOrdersPage,
  DeliverySchedulePage,
  OrderDetailsPage,
  InvoicesPage,
  PendingActionsPage,
} from './pages/orders';
import {
  AvailableEventsPage,
  MyBidsPage,
  SubmitBidPage,
  BidHistoryPage,
} from './pages/sourcing';
import {
  CompanyProfilePage,
  CertificationsPage,
  CompanyUsersPage,
  DeliveryZonesPage,
} from './pages/company';
import {
  ScorecardPage,
  FeedbackPage,
} from './pages/performance';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1 
    } 
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider portalType="supplier">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Routes>
                      <Route path="/" element={<DashboardPage />} />
                      {/* Sourcing */}
                      <Route path="/sourcing" element={<AvailableEventsPage />} />
                      <Route path="/sourcing/available" element={<AvailableEventsPage />} />
                      <Route path="/sourcing/bids" element={<MyBidsPage />} />
                      <Route path="/sourcing/submit/:eventId" element={<SubmitBidPage />} />
                      <Route path="/sourcing/history" element={<BidHistoryPage />} />
                      {/* Orders */}
                      <Route path="/orders" element={<PurchaseOrdersPage />} />
                      <Route path="/orders/purchase-orders" element={<PurchaseOrdersPage />} />
                      <Route path="/orders/purchase-orders/:poId" element={<OrderDetailsPage />} />
                      <Route path="/orders/pending-actions" element={<PendingActionsPage />} />
                      <Route path="/orders/delivery" element={<DeliverySchedulePage />} />
                      <Route path="/orders/invoices" element={<InvoicesPage />} />
                      {/* Performance */}
                      <Route path="/performance" element={<ScorecardPage />} />
                      <Route path="/performance/scorecard" element={<ScorecardPage />} />
                      <Route path="/performance/feedback" element={<FeedbackPage />} />
                      {/* Company */}
                      <Route path="/company" element={<CompanyProfilePage />} />
                      <Route path="/company/profile" element={<CompanyProfilePage />} />
                      <Route path="/company/certifications" element={<CertificationsPage />} />
                      <Route path="/company/zones" element={<DeliveryZonesPage />} />
                      <Route path="/company/users" element={<CompanyUsersPage />} />
                    </Routes>
                  </AppLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </QueryClientProvider>
  );
}
